"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Subdivision;
(function (Subdivision) {
    Subdivision[Subdivision["Beat"] = 0] = "Beat";
    Subdivision[Subdivision["Bar"] = 1] = "Bar";
})(Subdivision = exports.Subdivision || (exports.Subdivision = {}));
var ScheduleTime = /** @class */ (function () {
    function ScheduleTime() {
    }
    return ScheduleTime;
}()); //avoid confusion with any
exports.ScheduleTime = ScheduleTime;
var ScheduleAsap = /** @class */ (function (_super) {
    __extends(ScheduleAsap, _super);
    function ScheduleAsap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ScheduleAsap;
}(ScheduleTime));
exports.ScheduleAsap = ScheduleAsap;
var ScheduleAt = /** @class */ (function (_super) {
    __extends(ScheduleAt, _super);
    function ScheduleAt(at) {
        var _this = _super.call(this) || this;
        _this.at = at;
        return _this;
    }
    return ScheduleAt;
}(ScheduleTime));
exports.ScheduleAt = ScheduleAt;
var ScheduleNext = /** @class */ (function (_super) {
    __extends(ScheduleNext, _super);
    function ScheduleNext(next) {
        var _this = _super.call(this) || this;
        _this.next = next;
        return _this;
    }
    return ScheduleNext;
}(ScheduleTime));
exports.ScheduleNext = ScheduleNext;
var ScheduleIn = /** @class */ (function (_super) {
    __extends(ScheduleIn, _super);
    function ScheduleIn(inn) {
        var _this = _super.call(this) || this;
        _this.inn = inn;
        return _this;
    }
    return ScheduleIn;
}(ScheduleTime));
exports.ScheduleIn = ScheduleIn;
var ScheduleAfter = /** @class */ (function (_super) {
    __extends(ScheduleAfter, _super);
    function ScheduleAfter(objects) {
        var _this = _super.call(this) || this;
        _this.objects = objects;
        return _this;
    }
    return ScheduleAfter;
}(ScheduleTime));
exports.ScheduleAfter = ScheduleAfter;
var ScheduleRelativeTo = /** @class */ (function (_super) {
    __extends(ScheduleRelativeTo, _super);
    function ScheduleRelativeTo(object, delta) {
        var _this = _super.call(this) || this;
        _this.object = object;
        _this.delta = delta;
        return _this;
    }
    return ScheduleRelativeTo;
}(ScheduleTime));
exports.ScheduleRelativeTo = ScheduleRelativeTo;
var Time;
(function (Time) {
    Time.Asap = new ScheduleAsap();
    function At(time) {
        return new ScheduleAt(time);
    }
    Time.At = At;
    function Next(time) {
        return new ScheduleNext(time);
    }
    Time.Next = Next;
    function In(time) {
        return new ScheduleIn(time);
    }
    Time.In = In;
    function After(objects) {
        return new ScheduleAfter(objects);
    }
    Time.After = After;
    function RelativeTo(object, delta) {
        return new ScheduleRelativeTo(object, delta);
    }
    Time.RelativeTo = RelativeTo;
})(Time = exports.Time || (exports.Time = {}));
//playback mode
var PlaybackMode = /** @class */ (function () {
    function PlaybackMode(offset, duration) {
        this.offset = offset;
        this.duration = duration;
    }
    return PlaybackMode;
}());
exports.PlaybackMode = PlaybackMode;
var OneshotMode = /** @class */ (function (_super) {
    __extends(OneshotMode, _super);
    function OneshotMode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OneshotMode;
}(PlaybackMode));
exports.OneshotMode = OneshotMode;
var LoopMode = /** @class */ (function (_super) {
    __extends(LoopMode, _super);
    function LoopMode(times, offset, duration) {
        var _this = _super.call(this, offset, duration) || this;
        _this.times = times;
        return _this;
    }
    return LoopMode;
}(PlaybackMode));
exports.LoopMode = LoopMode;
var Playback;
(function (Playback) {
    function Oneshot(offset, duration) {
        return new OneshotMode(offset, duration);
    }
    Playback.Oneshot = Oneshot;
    function Loop(times, offset, duration) {
        return new LoopMode(times, offset, duration);
    }
    Playback.Loop = Loop;
})(Playback = exports.Playback || (exports.Playback = {}));
//transition mode
var TransitionMode = /** @class */ (function () {
    function TransitionMode() {
    }
    return TransitionMode;
}());
exports.TransitionMode = TransitionMode;
var TransitionImmediately = /** @class */ (function (_super) {
    __extends(TransitionImmediately, _super);
    function TransitionImmediately() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TransitionImmediately;
}(TransitionMode));
exports.TransitionImmediately = TransitionImmediately;
var TransitionWithCrossfade = /** @class */ (function (_super) {
    __extends(TransitionWithCrossfade, _super);
    function TransitionWithCrossfade(duration) {
        var _this = _super.call(this) || this;
        _this.duration = duration;
        return _this;
    }
    return TransitionWithCrossfade;
}(TransitionMode));
exports.TransitionWithCrossfade = TransitionWithCrossfade;
var Transition;
(function (Transition) {
    Transition.Immediately = new TransitionImmediately();
    function CrossFade(duration) {
        return new TransitionWithCrossfade(duration);
    }
    Transition.CrossFade = CrossFade;
})(Transition = exports.Transition || (exports.Transition = {}));
//stopping mode
var StoppingMode = /** @class */ (function () {
    function StoppingMode() {
    }
    return StoppingMode;
}());
exports.StoppingMode = StoppingMode;
var StopAsap = /** @class */ (function (_super) {
    __extends(StopAsap, _super);
    function StopAsap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StopAsap;
}(StoppingMode));
exports.StopAsap = StopAsap;
var StopWithFadeOut = /** @class */ (function (_super) {
    __extends(StopWithFadeOut, _super);
    function StopWithFadeOut(duration) {
        var _this = _super.call(this) || this;
        _this.duration = duration;
        return _this;
    }
    return StopWithFadeOut;
}(StoppingMode));
exports.StopWithFadeOut = StopWithFadeOut;
var Stop;
(function (Stop) {
    Stop.Asap = new StopAsap();
    function FadeOut(duration) {
        return new StopWithFadeOut(duration);
    }
    Stop.FadeOut = FadeOut;
})(Stop = exports.Stop || (exports.Stop = {}));
//scheduled object
var Parameter;
(function (Parameter) {
    Parameter[Parameter["Offset"] = 0] = "Offset";
    Parameter[Parameter["StartTime"] = 1] = "StartTime";
    Parameter[Parameter["Duration"] = 2] = "Duration";
    Parameter[Parameter["DurationRatio"] = 3] = "DurationRatio";
    Parameter[Parameter["Amplitude"] = 4] = "Amplitude";
    Parameter[Parameter["Panning"] = 5] = "Panning";
    Parameter[Parameter["Reverb"] = 6] = "Reverb";
    Parameter[Parameter["Delay"] = 7] = "Delay";
    Parameter[Parameter["Loop"] = 8] = "Loop";
    Parameter[Parameter["PlaybackRate"] = 9] = "PlaybackRate";
    Parameter[Parameter["TimeStretchRatio"] = 10] = "TimeStretchRatio";
})(Parameter = exports.Parameter || (exports.Parameter = {}));



//////////////////
// WEBPACK FOOTER
// ./~/schedulo/lib/types.js
// module id = 459
// module chunks = 3